"use client";

"use client";

import Image from "@/components/Image";
import { useEffect, useState, useContext, useRef } from "react";
import Cookies from "@/utils/Cookie";
import useRouter from "@/hooks/useRouter";
import { Content, ContentItem } from "@/components/Book";
import useLocation from "@/hooks/useLocation";
import { useGlobal } from "@/components/Global";

import { getLocal, replaceParams, replaceParamsStore } from "@/utils/utils";
import { historyFun } from "../utils";
import { getImmigration } from "@/api/condition";
import SearchDom from "./SearchDom";
import StandardDom from "./StandardDom";
import StoreDom from "./StoreDom";
import s from "./ListDom.module.css";
import fangdajing02 from "@/images/fangdajing02.png";
import dingwei from "@/images/dingwei.png";
import shuaxin from "@/images/shuaxin.png";
import { Toast } from "antd-mobile";

const Page = (props) => {
  const {
    cityData = [],
    book,
    getData,
    setIsOnFocus,
    isOnFocus,
    urlParams,
  } = props;
  const dels = urlParams?.dels;
  const effluentStandard = urlParams?.effluentStandard; // 排放标准
  const callBackField = urlParams?.callBackField; // 排放标准
  const returnPath = decodeURIComponent(urlParams?.returnPath); // 回调url
  const router = useRouter();
  const [locationCity, setLocationCity] = useState();
  const [historyCity, setHistoryCity] = useState([]); // 历史选择的数据, 格式：[{cityId:'', cityName:'',citySpell:''},{},...]
  const [cityInfoLng, getZB] = useLocation({ isGetCity: 1, isAuto: 0 });

  const [value, setValue] = useState({});
  const [standardVisiable, setStandardVisiable] = useState(false); //标注检测结果弹层开关
  const [standardInfo, setStandardInfo] = useState({}); // 标注检测结果
  const [selectedInfo, setSelectedInfo] = useState([]); // 选中城市的门店信息
  const [storeVisiable, setStoreVisiable] = useState(false); // 门店弹层开关
  const ref2 = useRef();
  const [h, setH] = useState(0);
  const toastHandler = useRef();
  const [sessionLocationCityLoading] = useGlobal([
    "sessionLocationCityLoading",
  ]);

  useEffect(() => {
    getLocationCity();
    getHistoryData();
    getHeight();

    return () => {
      toastHandler.current?.close();
    };
  }, []);

  useEffect(() => {
    getLocationCity();
  }, [sessionLocationCityLoading]);

  const getHeight = () => {
    setH(window.innerHeight);
  };

  useEffect(() => {
    if (cityData?.length > 0) {
      // 切换 有无门店的城市也从新请求history
      getHistoryData();
    }
  }, [cityData]);

  useEffect(() => {
    // 有历史城市，并且历史城市刷新完毕，从新计算
    if (historyCity?.length > 0) {
      book.reComputed({ isToTop: 1 });
    }
  }, [historyCity]);

  // 获取localStorage里
  const getHistoryData = () => {
    const d2 = getLocal("historyCity");

    const str = Cookies.get("city");
    const value = str ? JSON.parse(str) : {};
    let cityCode = urlParams?.cityCode;
    let cityName = urlParams?.cityName;
    if (!cityCode) {
      cityCode = value.cityCode;
      cityName = value.cityName;
    }

    setValue({ cityName, cityCode });

    if (d2) {
      const arr = JSON.parse(d2);
      const crr = arr.filter((item) => {
        if (item.cityAreaId !== cityCode) {
          return item.cityAreaId;
        }
      });
      const rs = [];
      const trr = [];

      cityData.map((item) => {
        if (item.groupName === "HOT") return;
        if (item.cityList) {
          item.cityList.map((item2) => {
            trr.push(+item2.cityAreaId);
          });
        }
      });

      crr.map((item) => {
        if (trr.indexOf(+item.cityAreaId) > -1) {
          rs.push(item);
        }
      });

      setHistoryCity(rs);
    } else {
      // 如果没有历史城市，也需要从新计算一下
      book.reComputed({ isToTop: 1 });
    }
  };

  const getLocationCity = () => {
    let lc = Cookies.get("locationCity");

    if (lc) {
      lc = JSON.parse(lc);

      setLocationCity(lc);
    }
  };

  const shuaxinFun = () => {
    getZB();
  };

  const getCityItem = (o) => {
    let rs = {};
    cityData.map((item) => {
      if (item.groupName === "HOT") return;
      if (item.cityList) {
        item.cityList.map((item2) => {
          if (
            +item2.cityAreaId === +o.cityAreaId ||
            +item2.cityAreaId === +o.cityCode
          ) {
            rs = { ...item2 };
          }
        });
      }
    });

    return rs;
  };
  const selectedCityFun = (item2) => {
    const item = getCityItem(item2); // 根据item2的cityId 到cityData获取城市信息

    historyFun(value, item);
    if (effluentStandard) {
      // 国标检测+门店获取
      getStandard(item);
    } else {
      // 选中城市
      callbackFun({
        cityId: item.cityId,
        cityCode: item.cityAreaId,
        cityName: item.cityName,
        citySpell: item.citySpell,
      });
    }
  };
  //回调父级
  const callbackFun = (item) => {
    console.info(item);
    console.info(returnPath);
    if (!returnPath) {
      Toast.show({
        content: "缺少回调地址",
      });

      return;
    }

    Cookies.set("city", JSON.stringify(item));

    // toastHandler.current = Toast.show({
    //   icon: "loading",
    //   duration: 0,
    // });

    // 首页、列表选择城市会清空storeId
    // if (dels === "storeId") {
    //   Cookies.remove("storeId"); // 删除storeId，城市变化了，从新获取
    //   Cookies.set(
    //     "city",
    //     JSON.stringify({
    //       cityId: item.cityId,
    //       cityCode: item.cityCode,
    //       cityName: item.cityName,
    //       citySpell: item.citySpell
    //     })
    //   );

    // }

    let pam = "";
    if (urlParams.fromStore) {
      pam = replaceParamsStore(
        item,
        { checkedCity: 1 },
        urlParams,
        "callBackField,returnPath,dels,fromStore,storeId"
      );
    } else {
      Cookies.set("t_city", item.cityId);
      item.city = item.citySpell;

      pam = replaceParams(
        item,
        callBackField,
        urlParams,
        "callBackField,returnPath,dels,fromStore,storeId" // 选完城市，不带旧的storeId
      );
    }

    if (effluentStandard) {
      router.replace(
        `${returnPath.replace("/storeId", `/${item.store?.storeId}`)}${pam}`
      );
    } else {
      // console.log(item, callBackField, urlParams ,pam, returnPath);
      router.replace(`${returnPath}${pam}`);
    }
  };
  // 获取标准
  const getStandard = (item) => {
    setSelectedInfo(item);

    getImmigration({
      effluentStandard: urlParams?.effluentStandard,
      ucarId: urlParams?.ucarId,
      cityAreaId: item.cityAreaId,
    }).then((res) => {
      if (res?.immigration === 1) {
        // 0不可迁 1 可迁 2 待查
        if (item.stores.length === 1) {
          callbackFun({
            store: item.stores[0],
            cityId: item.cityId,
            cityCode: item.cityAreaId,
            cityName: item.cityName,
            citySpell: item.citySpell,
          });
        } else {
          setStoreVisiable(true);
        }
      } else {
        setStandardInfo(res);
        setStandardVisiable(true);
      }
    });
  };

  const confirmStandardFun = () => {
    setStandardVisiable(false);
    if (selectedInfo.stores.length > 1) {
      setStoreVisiable(true);
    } else {
      callbackFun({
        store: selectedInfo.stores[0],
        cityId: selectedInfo.cityId,
        cityCode: selectedInfo.cityAreaId,
        cityName: selectedInfo.cityName,
        citySpell: selectedInfo.citySpell,
      });
    }
  };

  // 渲染当前定位城市
  const renderNowCity = () => {
    if (!locationCity?.cityName && !sessionLocationCityLoading) return;
    return (
      <div
        className={`${s.cityhot}`}
        style={{ display: !effluentStandard ? "" : "none" }}
      >
        <div className={s.cityhot2}>当前定位城市</div>
        <div className={s.citygroup3}>
          {sessionLocationCityLoading ? (
            <div className={s.font42}>正在定位...</div>
          ) : (
            <div className={s.citygroup4}>
              <Image
                alt=""
                src={dingwei}
                className={s.classIcon2}
                width={20}
                height={20}
              ></Image>
              {locationCity?.cityName ? (
                <span
                  className={s.font4}
                  onClick={() => {
                    selectedCityFun(locationCity);
                  }}
                >
                  {locationCity?.cityName}
                </span>
              ) : (
                <span className={s.font4}>定位失败</span>
              )}
            </div>
          )}
          <div
            className={s.citygroup4}
            onClick={() => {
              shuaxinFun();
            }}
          >
            <Image
              alt=""
              src={shuaxin}
              className={`${s.classIcon2}${
                sessionLocationCityLoading ? ` ${s.rotationAll}` : ""
              }`}
              width={20}
              height={20}
            ></Image>
            <span className={s.font5}>刷新定位</span>
          </div>
        </div>
      </div>
    );
  };

  // 当前选择城市
  const renderSelectedCity = () => {
    if (!value?.cityName) return;

    return (
      <div key={`citySelect`}>
        <div className={`${s.cityhot}`}>
          <div className={s.cityhot2}>当前选择城市</div>
          <div className={s.citygroup}>
            <div
              key={`citySelect2`}
              className={s.cityborder}
              onClick={() => {
                selectedCityFun(value);
              }}
            >
              {value?.cityName}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // 渲染历史选择城市
  const renderHistoryCity = () => {
    if (historyCity?.length > 0) {
      return (
        <div key={`cityhistory`}>
          <div className={`${s.cityhot}`}>
            <div className={s.cityhot2}>历史选择城市</div>
            <div className={s.citygroup}>
              {historyCity.map((item, idx2) => {
                return (
                  <div
                    key={`cityhistory2${idx2}`}
                    className={s.cityborder}
                    onClick={() => {
                      selectedCityFun(item);
                    }}
                  >
                    {item.cityName}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      );
    }
  };

  // 渲染热门城市 、 全部城市
  const renderDom = () => {
    // console.log('renderDom', cityData)

    return cityData.map((item, idx) => {
      if (item.groupName === "HOT") {
        return (
          <div key={`cityhot`}>
            <div className={`${s.cityhotdiv}`}>
              <div className={s.cityhot2}>热门城市</div>
              <div className={s.citygroup}>
                {item.cityList.map((item2, idx2) => {
                  return (
                    <div
                      key={`cityhot2${idx2}`}
                      className={s.cityborder}
                      onClick={() => {
                        selectedCityFun(item2);
                      }}
                    >
                      {item2.cityName}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <ContentItem key={`cityindex_${idx}`} id={`cg_${item.groupName}`}>
            <div key={`cityindex_${idx}`} className={`${s.cityindex} `}>
              <div className={s.cityindex2}>{item.groupName}</div>
              <div className={`${s.citygroup} ${s.citygroup2}`}>
                {item.cityList.map((item2, idx2) => {
                  return (
                    <div
                      key={`cityhot2${idx2}`}
                      className={s.citynoborder}
                      onClick={() => {
                        selectedCityFun(item2);
                      }}
                    >
                      {item2.cityName}
                    </div>
                  );
                })}
              </div>
            </div>
          </ContentItem>
        );
      }
    });
  };

  return (
    <div className={s.listclass} style={{ height: `${h}px` }}>
      <SearchDom
        {...props}
        urlParams={urlParams}
        getData={getData}
        isOnFocus={isOnFocus}
        cityData={cityData}
        selectedCityFun={selectedCityFun}
        setIsOnFocus={setIsOnFocus}
        book={book}
      />
      <Content className={`${s.listclassbottom} `}>
        {isOnFocus ? null : (
          <div className={s.listclass2}>
            <ContentItem id={`cg_#`}>
              {renderNowCity()}
              {renderSelectedCity()}
              {renderHistoryCity()}
            </ContentItem>

            {renderDom()}
          </div>
        )}
      </Content>
      <StandardDom
        selectedInfo={selectedInfo}
        setStandardVisiable={setStandardVisiable}
        standardVisiable={standardVisiable}
        confirmStandardFun={confirmStandardFun}
        standardInfo={standardInfo}
      />
      <StoreDom
        selectedInfo={selectedInfo}
        callbackFun={callbackFun}
        storeVisiable={storeVisiable}
        setStoreVisiable={setStoreVisiable}
      />
    </div>
  );
};
export default Page;
